<template>
  <div>
    <BillssMonitoring :titlee="'Electric Bill'">

    </BillssMonitoring>
  </div>
</template>
<script>
  import BillssMonitoring from './BillssMonitoring'

  export default {
    components: {
      BillssMonitoring,
    },
  }
</script>
